import { render, staticRenderFns } from "./SelectInputSort.vue?vue&type=template&id=560cfab3&scoped=true&lang=pug"
import script from "./SelectInputSort.vue?vue&type=script&lang=js"
export * from "./SelectInputSort.vue?vue&type=script&lang=js"
import style0 from "./SelectInputSort.vue?vue&type=style&index=0&id=560cfab3&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560cfab3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/andrewatieh/WebstormProjects/JTCoffeeTheme/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('560cfab3')) {
      api.createRecord('560cfab3', component.options)
    } else {
      api.reload('560cfab3', component.options)
    }
    module.hot.accept("./SelectInputSort.vue?vue&type=template&id=560cfab3&scoped=true&lang=pug", function () {
      api.rerender('560cfab3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/forms/SelectInputSort.vue"
export default component.exports